function somenteNumeros(valor) {
    return  valor.replace(/[^\d]+/g,'') 
}

export default somenteNumeros;